import lineStyle from './pie.labelLine.lineStyle'

export default {
  name: "labelLine",
  nickname: "引导线样式",
  desc:
    '标签的视觉引导线样式，在 <a target="__blank" href="https://echarts.apache.org/zh/option.html#series-pie.label.position">label 位置</a> 设置为<code class="codespan">&#39;outside&#39;</code>的时候会显示视觉引导线。',
  type: "object",
  props: {
    show: {
      name: "show",
      nickname: "显示",
      desc: "是否显示视觉引导线。",
    },
    length: {
      name: "length",
      nickname: "长度",
      desc: "视觉引导线第一段的长度。",
    },
    length2: {
      name: "length2",
      nickname: "视觉引导项第二段的长度",
      desc: "视觉引导项第二段的长度。",
    },
    smooth: {
      name: "smooth",
      nickname: "平滑",
      desc:
        '是否平滑视觉引导线，默认不平滑，可以设置成 <code class="codespan">true</code> 平滑显示，也可以设置为 0 到 1 的值，表示平滑程度。',
      value: false,
      defaultValue: false,
    },
    lineStyle,
  },
}
